import vars from '../helpers';
import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);
import Parallax from 'parallax-js';

const gsap = window.gsap;
const HOME_TRANSITION_DUR = 1.9;
const MAX_POSITION = 20;

let isAnimating = false;

let started = false;
let finished = false;
let paused = false;

let swiper;
let slideParallax = [];
let tl1;
let tl2;
let tl3;
let fade;

let $body = document.querySelector('body');

// анимация выбора карточки
// const slidePickAnimation = (e, slides) => {
// 	let currentSlide = e.currentTarget;
// 	console.log(currentSlide)

// 	slides.forEach(slide => {
// 		let bgContainer = slide.querySelector('.slide__pictures');
// 		let pictures = bgContainer.querySelectorAll('img');
// 		pictures.forEach(picture => {
// 			fade = gsap.timeline().to(picture, 0.7, {opacity: 0});
// 			fade.play();
// 		});
// 	});
// };

// const slidePickEvent = () => {
// 	let slides = document.querySelectorAll('.swiper-slide');

// 	slides.forEach(slide => {
// 		let linkElement = slide.querySelector('.slide__imgwrapper');
// 		linkElement.addEventListener('click', (e) => {
// 			e.preventDefault();
// 			slidePickAnimation(e, slides);
// 		});
// 	});
// };

// паралакс на слайде
const slideParallaxInit = () => {
	if (vars.isMobile()) {
		return;
	}

	let scenes = document.querySelectorAll('.swiper-slide-active .slide__pictures, .swiper-slide-prev .slide__img-part, .swiper-slide-next .slide__img-part');

	scenes.forEach((scene) => {
		slideParallax.push(new Parallax(scene, {
			scalarX: 5,
			scalarY: 2,
		}));
	});
};

const slideParallaxDestroy = () => {
	slideParallax.forEach((slideParallaxCurrent) => {
		slideParallaxCurrent.destroy();
	});

	slideParallax = [];
};

// слайдер
const sliderInit = (slider, initSlide) => {
	swiper = new Swiper(slider, {
		loop: true,
		speed: 800,
		slidesPerView: 1,
		navigation: {
			nextEl: '.slider__next',
			prevEl: '.slider__prev',
		},
		breakpoints: {
			1025: {
				slidesPerView: 3,
				spaceBetween: 20,
				centeredSlides: true,
			},
		},
	});

	setTimeout(() => {
		const slide = initSlide ? initSlide - 1 : 0;

		swiper.slideToLoop(slide);
	}, 20);

	swiper.on('slideChange', (event) => {
		vars.$document.trigger('slider-change-home', event);
	});

	if (!vars.isMobile()) {
		swiper.on('slideChange', () => {
			slideParallaxInit();
			slideParallaxDestroy();
		});
		swiper.on('slideChangeTransitionStart', () => {
			slideParallaxInit();
		});
	}
};

const sliderDestroy = () => {
	swiper.destroy();
};

// скролл к якорю
const sectionScroll = (e) => {
	e.preventDefault();
	let target = e.currentTarget.getAttribute('data-scroll');
	let offset = $(`${target}`).offset().top;
	window.scrollTo(0, offset);
};

// дизейбл на время анимации
const disableBody = () => {
	$body.setAttribute('disabled', true);
	$body.classList.add('is-disabled');
	window.addEventListener('wheel', (e) => {
		// // e.preventDefault();
		// e.stopPropagation();
	});
	window.removeEventListener('wheel', wheelHandler); // eslint-disable-line no-use-before-define
};

const enableBody = () => {
	$body.setAttribute('disabled', false);
	$body.classList.remove('is-disabled');
	window.removeEventListener('wheel', (e) => {
		e.preventDefault();
		e.stopPropagation();
	});
	window.addEventListener('wheel', wheelHandler); // eslint-disable-line no-use-before-define
};

const isEnter = () => {
	let homeSlider = document.querySelector('.home__slider');

	sliderInit(homeSlider, vars.$html.attr('data-number-page'));

	let cards = document.querySelector('.home__cards');

	const tldown = gsap.timeline({
		onStart() {
			$('#home-bottom').addClass('is-vision-desktop');
			$('#home-top').addClass('is-hide-desktop');
		},
	});

	disableBody();

	vars.$document.trigger('home-scroll-down');

	let elems = document.querySelectorAll('.is-visually-hidden-desktop');
	let card2 = cards.querySelector('[data-card=princess]');
	let card4 = cards.querySelector('[data-card=vitamin]');

	let sliderBtn = document.querySelectorAll('.slider__button');
	let firstStartSlide = document.querySelector('.slide-limoncello');
	let activeSlideText = firstStartSlide.querySelector('.slide__text');
	let activeSlideHeading = firstStartSlide.querySelector('.slide__heading');

	card2.style.transition = 'none';
	card4.style.transition = 'none';

	elems.forEach((item) => {
		item.classList.remove('is-visually-hidden-desktop');
	});

	tl1 = gsap.timeline()
		.from(sliderBtn, 0.5, {opacity: 0})
		.from(activeSlideText, 0.5, {
			opacity: 0,
			clearProps: 'all',
		}, 4.6)
		.from(activeSlideHeading, 0.5, {
			opacity: 0,
			clearProps: 'all',
		}, 4.6);

	tl1.play();

	tldown.from($('.page-container'), {
		delay: 0.5,
		duration: HOME_TRANSITION_DUR,
		autoAlpha: 0,
		clearProps: 'all',
	});

	setTimeout(() => {
		slideParallaxInit();
	}, 1000);

	setTimeout(() => {
		$('#home-bottom').removeClass('side-slides-hold');
	}, 600);

	setTimeout(() => {
		let activeSlide = document.querySelector('.swiper-slide-active');
		let activeSlideBtn = activeSlide.querySelector('.slide__button');
		let activeSlideNumber = activeSlide.querySelector('.slide__number');
		let slideImgInner = document.querySelectorAll('.start-style');

		activeSlideNumber.style.transitionDelay = '0.5s';
		activeSlideBtn.style.transitionDelay = '0.5s';

		$('#home-bottom').removeClass('center-slide-hold');

		setTimeout(() => {
			activeSlideNumber.style.transitionDelay = '0s';
			activeSlideBtn.style.transitionDelay = '0s';

			enableBody();
		}, 1000);

		setTimeout(() => {
			slideImgInner.forEach((el) => {
				el.classList.remove('start-style');
			});
		}, 300);
	}, 400);
};

// анимация титульной секции при входе
const homeAnimation = (option) => {
	if (isAnimating) {
		return;
	}

	isAnimating = true;

	let state = option === 'play';

	let elems = document.querySelectorAll('.is-visually-hidden-desktop');
	let lines = document.querySelectorAll('.is-visually-hidden-desktop--line');
	let cards = document.querySelectorAll('.home__card');
	let firstcard = document.querySelector('[data-card="larvotto"]');
	let text = document.querySelector('.home__text-block');
	let svgs = document.querySelectorAll('.home__deco--svg');

	$('[data-card="champagne"], [data-card="spritz"], [data-card="larvotto"]').find('picture').removeClass('tohide').addClass('hide-last');

	function nextState() {
		disableBody();

		setTimeout(() => {
			elems.forEach((item) => {
				item.classList.remove('is-visually-hidden-desktop');
			});

			firstcard.classList.remove('is-opacity');

			gsap.from('.js-animate--fromright', {
				duration: 2,
				x: 900,
				clearProps: 'all',
			});

			gsap.from('.js-animate--fromleft', {
				duration: 2,
				x: -900,
				clearProps: 'all',
			});
		}, 500);

		setTimeout(() => {
			cards.forEach((card) => {
				card.classList.remove('is-opacity');
			});
		}, 1600);

		setTimeout(() => {
			lines.forEach((line) => {
				line.classList.remove('is-visually-hidden-desktop--line');
			});

			cards.forEach((card) => {
				card.classList.remove('is-prepared');
			});

			svgs.forEach((svg) => {
				svg.classList.remove('is-prepared');
			});

			text.classList.remove('is-prepared');

			gsap.from('.home__deco--line', {
				duration: 1.3,
				width: 0,
				clearProps: 'all',
			});
		}, 2500);

		setTimeout(() => {
			window.removeEventListener('wheel', (e) => {
				e.preventDefault();
			});
		}, 2501);

		setTimeout(() => {
			enableBody();

			isAnimating = false;
		}, 4000);
	}

	if (state) {
		nextState();
	} else if (state) {
		elems.forEach((item) => {
			item.classList.add('is-visually-hidden-desktop');
		});

		cards[0].classList.add('is-opacity');

		cards.forEach((card) => {
			card.classList.add('is-opacity');
		});

		lines.forEach((line) => {
			line.classList.add('is-visually-hidden-desktop--line');
		});

		cards.forEach((card) => {
			card.classList.add('is-prepared');
		});

		svgs.forEach((svg) => {
			svg.classList.add('is-prepared');
		});

		text.classList.add('is-prepared');

		isAnimating = false;
	}
};

// анимация смены секции
const sectionSwitch = (option) => {
	if (isAnimating) {
		return;
	}

	isAnimating = true;

	let isInitialState = option === 'down';

	const $homeTop = document.querySelector('#home-top');
	const $homeBottom = document.querySelector('#home-bottom');

	const $cards = document.querySelector('.home__cards');
	const $miscElems = document.querySelectorAll('.tohide');
	const $hideLast = document.querySelectorAll('.hide-last');

	if (isInitialState) {
		disableBody();

		vars.$document.trigger('home-scroll-down');

		sliderInit(document.querySelector('.home__slider'));

		const $card2 = $cards.querySelector('[data-card=princess]');
		const $card3 = $cards.querySelector('[data-card=linomcello]');
		const $card4 = $cards.querySelector('[data-card=vitamin]');
		const $slideImg = document.querySelector('.swiper-slide-active .slide__imgwrapper--desktop');
		const $slideImgNext = document.querySelector('.swiper-slide-next .slide__imgwrapper--desktop');

		const $sliderBtn = document.querySelectorAll('.slider__button');
		const $firstStartSlide = document.querySelector('.slide-limoncello');
		const $activeSlideText = $firstStartSlide.querySelector('.slide__text');
		const $activeSlideHeading = $firstStartSlide.querySelector('.slide__heading');

		$card2.style.transition = 'none';
		$card4.style.transition = 'none';
		$slideImgNext.style.transition = 'none';

		const cardsProps = $cards.getBoundingClientRect();
		const card2Props = $card2.getBoundingClientRect();
		const card3Props = $card3.getBoundingClientRect();
		const slideImgProps = $slideImg.getBoundingClientRect();
		const slideImgNextProps = $slideImgNext.getBoundingClientRect();

		const cardsScale = slideImgProps.width / card3Props.width;

		const cardsX = slideImgProps.x -
			(cardsProps.x - (cardsProps.width * cardsScale - cardsProps.width) / 2 +
			(card3Props.x - cardsProps.x) * cardsScale);

		const cardsY = slideImgProps.y -
			(cardsProps.y - (cardsProps.height * cardsScale - cardsProps.height) / 2 +
			(card3Props.y - cardsProps.y) * cardsScale);

		const card2And4X = card3Props.x - (card2Props.x + card2Props.width) -
			(slideImgNextProps.x - (slideImgProps.x + slideImgProps.width)) / cardsScale;

		tl1 = gsap.timeline({
			onComplete() {
				const $activeSlide = document.querySelector('.swiper-slide-active');
				const $activeSlideBtn = $activeSlide.querySelector('.slide__button');
				const $activeSlideNumber = $activeSlide.querySelector('.slide__number');
				const $slideImgInner = document.querySelectorAll('.start-style');

				$activeSlideNumber.style.transitionDelay = '0.5s';
				$activeSlideBtn.style.transitionDelay = '0.5s';

				$homeBottom.classList.remove('center-slide-hold');

				setTimeout(() => {
					$activeSlideNumber.style.transitionDelay = '0s';
					$activeSlideBtn.style.transitionDelay = '0s';
					enableBody();
				}, 1000);

				setTimeout(() => {
					$slideImgInner.forEach((el) => {
						el.classList.remove('start-style');
					});
				}, 300);

				gsap.set([$homeTop, $homeBottom, $slideImgNext], {clearProps: 'all'});

				slideParallaxInit();

				isAnimating = false;
			},
		})
			.to($miscElems, {
				opacity: 0,
			})
			.to($cards, {
				duration: 2.75,
				delay: 0.75,
				scale: cardsScale,
				x: cardsX,
				y: cardsY,
			}, 0)
			.to($card2, {
				duration: 2.75,
				delay: 0.75,
				transition: 'none',
				x: card2And4X,
			}, 0)
			.to($card4, {
				duration: 2.75,
				delay: 0.75,
				transition: 'none',
				x: -card2And4X,
			}, 0)
			.call(() => {
				$homeBottom.classList.add('is-vision-desktop');
			})
			.fromTo($homeBottom, {
				opacity: 0,
			}, {
				opacity: 1,
			})
			.to($homeTop, {
				onComplete() {
					$homeTop.classList.add('is-hide-desktop');
				},
				opacity: 0,
			})
			.call(() => {
				$homeBottom.classList.remove('side-slides-hold');
			})
			.from($sliderBtn, {
				opacity: 0,
			}, 3.5)
			.from([$activeSlideText, $activeSlideHeading], {
				opacity: 0,
				clearProps: 'all',
			}, 3.5)
			.to($hideLast, {
				opacity: 0,
			});

		tl1.play();
	} else if (!isInitialState) {
		disableBody();

		vars.$document.trigger('home-scroll-top');

		const $card2 = $cards.querySelector('[data-card=princess]');
		const $card3 = $cards.querySelector('[data-card=linomcello]');
		const $card4 = $cards.querySelector('[data-card=vitamin]');
		const $slideImg = document.querySelector('.slide__imgwrapper--desktop');

		const $sliderBtn = document.querySelectorAll('.slider__button');
		const $firstStartSlide = document.querySelector('.slide-limoncello');
		const $activeSlideText = $firstStartSlide.querySelector('.slide__text');
		const $activeSlideHeading = $firstStartSlide.querySelector('.slide__heading');

		const cardsProps = $cards.getBoundingClientRect();
		const card3Props = $card3.getBoundingClientRect();
		const slideImgProps = $slideImg.getBoundingClientRect();

		const cardsScale = slideImgProps.width / card3Props.width;

		const cardsX = slideImgProps.x -
			(cardsProps.x - (cardsProps.width * cardsScale - cardsProps.width) / 2 +
				(card3Props.x - cardsProps.x) * cardsScale);

		const cardsY = slideImgProps.y -
			(cardsProps.y - (cardsProps.height * cardsScale - cardsProps.height) / 2 +
				(card3Props.y - cardsProps.y) * cardsScale);

		// card2.style.transition = 'none';
		// card4.style.transition = 'none';

		tl1 = gsap.timeline({
			onComplete() {
				const $slideImgInner = document.querySelectorAll('.start-style');

				setTimeout(() => {
					enableBody();
				}, 1000);

				setTimeout(() => {
					$slideImgInner.forEach((el) => {
						el.classList.add('start-style');
					});
				}, 300);

				gsap.set([$homeTop, $homeBottom], {clearProps: 'all'});

				isAnimating = true;
			},
		})
			.to($sliderBtn, {
				opacity: 0,
			}, 3.5)
			.to($activeSlideText, {
				opacity: 0,
				clearProps: 'all',
			}, 3.5)
			.to($activeSlideHeading, {
				opacity: 0,
				clearProps: 'all',
			}, 3.5)
			.from($hideLast, {
				opacity: 0,
				clearProps: 'all',
			})
			.from($miscElems, {
				opacity: 0,
				clearProps: 'all',
			})
			.from($cards, {
				duration: 2.75,
				delay: 0.75,
				scale: cardsScale,
				x: cardsX,
				y: cardsY,
			}, 0)
			.from($card2, {
				duration: 2.75,
				delay: 0.75,
				xPercent: 13,
			}, 0)
			.from($card4, {
				duration: 2.75,
				delay: 0.75,
				xPercent: -13,
			}, 0)
			.call(() => {
				$homeBottom.classList.remove('is-vision-desktop');
			})
			.fromTo($homeBottom, {
				opacity: 1,
			}, {
				opacity: 0,
			})
			.from($homeTop, {
				onComplete() {
					$homeTop.classList.remove('is-hide-desktop');
				},
				opacity: 0,
			});

		tl1.play();

		sliderDestroy();

		$homeBottom.classList.add('side-slides-hold', 'center-slide-hold');
	}
};

// действие на колёскио мыши
const wheelHandler = () => {
	window.removeEventListener('wheel', wheelHandler);

	let top = document.querySelector('.home__section--1');

	if (!top.classList.contains('is-hide-desktop')) {
		sectionSwitch('down');
	} else {
		// sectionSwitch("up");
		return;
	}

	setTimeout(() => {
		window.addEventListener('wheel', wheelHandler);
	}, 1800);
};

// цикличная анимация кнопки "вниз"
const scrollButtonAnimate = (button) => {
	let position = 0;

	function animate() {
		position += 1.3;

		if (started === false && paused === false) {
			started = true;
			finished = false;
		}

		if (paused === true) {
			position = MAX_POSITION;
		}

		if (position > MAX_POSITION && paused === false) {
			position = 0;
			finished = true;
			started = false;
		}

		button.style.transform = `translateY(${position}px)`;

		setTimeout(animate, 100);
	}

	animate();
};

// ховер кнопки "вниз"
const scrollbuttonHover = (button) => {
	button.addEventListener('mouseenter', () => {
		paused = true;
	});
	button.addEventListener('mouseleave', () => {
		paused = false;
	});
};

const scrollbuttonUnhover = (button) => {
	button.removeEventListener('mouseenter', () => {
		paused = true;
	});
	button.removeEventListener('mouseleave', () => {
		paused = false;
	});
};

function init() {
	let homeSlider = document.querySelector('.home__slider');
	let homeScrollButton = document.querySelector('.home__scroller');

	if (screen.width > 1024) {
		if (!vars.$html.hasClass('is-enter')) {
			homeAnimation('play');
		} else {
			isEnter();
		}

		scrollButtonAnimate(homeScrollButton);
		scrollbuttonHover(homeScrollButton);

		homeScrollButton.addEventListener('click', (e) => {
			e.preventDefault();

			sectionSwitch('down');
		});
	} else {
		sliderInit(homeSlider, vars.$html.attr('data-number-page'));
	}
}

function destroy() {
	let homeScrollButton = document.querySelector('.home__scroller');

	if (screen.width > 1024) {
		window.removeEventListener('wheel', wheelHandler);

		slideParallaxInit();
		slideParallaxDestroy();
		sliderDestroy();

		homeScrollButton.removeEventListener('click', (e) => {
			e.preventDefault();

			sectionSwitch('down');
		});

		scrollbuttonUnhover(homeScrollButton);
	} else {
		sliderDestroy();
	}
}

export default {
	init,
	destroy,
};
